import React, { useState, useEffect } from 'react';
import { Flex, Row, Col, Statistic, Card } from 'antd'
import Icon, { ArrowUpOutlined, CloseCircleFilled, UserOutlined, BankOutlined, StopOutlined, ClockCircleOutlined, CloseCircleOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import { isMobile } from 'react-device-detect';

export default function StatisticComponent(props) {
    const { color, title, value, icon } = props
    const initSecond = 1000;
    const loop = 20;
    const [secondsLeft, setSecondsLeft] = useState(initSecond);
    const [currentValue, setCurrentValue] = useState(0);
    const [timerId, setTimeId] = useState(null);

    useEffect(() => {
        if (value > 0) {
            setTimeId(setInterval(() => {
                //   setSecondsLeft((prevSeconds) => prevSeconds - initSecond/loop);
                //   console.log(secondsLeft)
                // console.log("Value", value, currentValue + (value / loop))
                setCurrentValue((current) => current + (value / loop))
            }, initSecond / loop))
        }
        return () => clearInterval(timerId);
    }, [value]); // Re-run effect if secondsLeft changes

    useEffect(() => {
        if (value>0 && currentValue>0 && currentValue >= value) {
            setCurrentValue(value)
            clearInterval(timerId)
            // console.log("STOP")
            return; // Stop the timer when it reaches zero
        }

        // return () => clearInterval(timerId);
    }, [currentValue]); // Re-run effect if secondsLeft changes

    return (
        <Card variant="borderless" style={{ minWidth: isMobile?"auto":"250px", width:isMobile?"180px":"auto", borderLeft: `.4em solid ${color}`, padding:isMobile?"0px":"14px" }}>
            <Flex justify='space-between' align='center' style={{height:'100%'}}>
                <Flex vertical>
                    <div style={{ textTransform: 'uppercase', fontWeight: 700, fontSize: ".8rem", color: color }}>{title}</div>
                    <div style={{ fontSize: isMobile?'24pt':'30pt', fontWeight: 'bold', color: "#5a5c69" }}>{Math.floor(currentValue)}</div>
                </Flex>
                <Flex style={{ color: "#dddfeb", fontSize: isMobile?"24pt":"40pt" }}>
                    {icon}
                </Flex>
            </Flex>
        </Card>
    )
}